"use client"
import { ReactNode } from "react"
import styled from "styled-components"
import {
  darkBlueBackground,
  darkBlueBorder,
  yellow
} from "../components/colors"

const Container = styled.div`
  padding-top: 0px;
  padding-left: 28px;
  padding-right: 28px;
  padding-bottom: 28px;
  border-radius: 32px;
  box-sizing: border-box;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 1px ${yellow} solid;
  width: 100%;
  /* background-image: linear-gradient(
    to bottom right,
    ${darkBlueBackground},
    ${darkBlueBorder}
  ); */
`

const Title = styled.span`
  font-size: 24px;
  font-weight: bold;
  text-transform: uppercase;
  background-color: ${darkBlueBorder};
  border: 1px solid ${yellow};
  border-radius: 12px;
  padding: 8px 48px;
  color: ${yellow};
  position: relative;
  top: -25px;
`

export const SectionTransparent: React.FC<{
  className?: string
  children?: ReactNode | string | (ReactNode | string)[]
  title?: string
  style?: React.CSSProperties
}> = ({ children = [], className = "", title, style }) => {
  return (
    <Container style={style} className={className}>
      {title && <Title>{title}</Title>}
      {children}
    </Container>
  )
}
